import { Component, OnInit } from '@angular/core';
import { ApiService, DashboardSummary } from '../../core/api.service';

@Component({
  selector: 'ch-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  summary: DashboardSummary | null = null;
  loading = false;
  error = '';

  constructor(private readonly api: ApiService) {}

  ngOnInit(): void {
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    this.error = '';
    try {
      this.summary = await this.api.dashboardSummary();
    } catch {
      this.error = 'Could not load dashboard summary.';
    } finally {
      this.loading = false;
    }
  }

  money(cents: number | undefined): string {
    const value = Math.round((cents || 0) / 100);
    return `KSh ${value.toLocaleString()}`;
  }
}
